import React from "react";
import {AutoCompleteProps, FormItemProps} from "antd";
import {useTranslation} from "react-i18next";
import _ from "lodash";
// components
import {BaseOptionType, DefaultOptionType} from "antd/lib/select";
import {InputField} from "@bezlimit/bezlimit-ui";
import {Rules} from "../../forms/rules";

const AddressField: React.FC<IProps> = React.memo(({formItemProps, autoCompleteProps}) => {
    const {t} = useTranslation();

    return (
        <InputField.AutoComplete
            autoCompleteProps={autoCompleteProps}
            formItemProps={{
                ...formItemProps,
                name: formItemProps?.name ? formItemProps.name : "address"
            }}
        />
    );
});

interface IProps {
    formItemProps?: FormItemProps<any>;
    autoCompleteProps?: AutoCompleteProps<any, BaseOptionType | DefaultOptionType>;
}

export default AddressField;
